import { Container } from "@/components/layout/Container"
import BuyNowButton from "@/features/checkout/BuyNowButton"
import type { TreatmentProps } from "@/content/treatments"
import { getTreatmentItem } from "@/content/prices"
import { imageBaseURL } from "@/lib/utils"

interface TreatmentCtaProps {
	treatment: TreatmentProps
}

/**
 * Sección 6 (CTA final): título + subtítulo sobre un fondo con gradiente azul y un
 * motivo celular abstracto, con mucho padding. Solo dos botones de compra (básico
 * y completo); no repite las tarjetas de la sección de planes.
 */
export function TreatmentCta({ treatment }: TreatmentCtaProps): React.JSX.Element {
	const basico = getTreatmentItem(treatment.id, "two")
	const completo = getTreatmentItem(treatment.id, "four")
	const basicoItem = { id: treatment.id, priceId: basico.priceId, amount: 1, duration: "two" as const }
	const completoItem = { id: treatment.id, priceId: completo.priceId, amount: 1, duration: "four" as const }

	return (
		<section className="relative isolate overflow-hidden bg-linear-to-br from-primary via-chart-3 to-chart-5 text-white">
			{/* Motivo celular abstracto (refuerza el tema de bioestimulación). */}
			<div
				aria-hidden
				className="pointer-events-none absolute inset-0 bg-cover bg-center opacity-10 mix-blend-screen"
				style={{ backgroundImage: `url(${imageBaseURL("backgrounds/bg-cells-white.svg")})` }}
			/>
			<Container className="relative py-20 text-center md:py-28 lg:py-32">
				<h2 className="mx-auto max-w-2xl text-balance font-heading text-3xl font-bold tracking-tight sm:text-4xl md:text-5xl">
					Empieza hoy tu tratamiento para {treatment.as} {treatment.name.toLowerCase()}
				</h2>
				<p className="mx-auto mt-5 max-w-xl text-pretty text-lg text-white/85">
					Natural, sin efectos secundarios y para toda la familia. Elige el paquete que mejor se adapta a ti y recíbelo
					en la puerta de tu casa.
				</p>
				<div className="mt-10 flex flex-col items-center justify-center gap-3 sm:flex-row">
					<BuyNowButton
						cartItem={completoItem}
						text="Comprar paquete completo"
						variant="secondary"
						size="lg"
						className="w-full sm:w-auto"
					/>
					<BuyNowButton
						cartItem={basicoItem}
						text="Comprar paquete básico"
						size="lg"
						className="w-full border-white/70 bg-transparent text-white hover:bg-white/10 sm:w-auto"
					/>
				</div>
			</Container>
		</section>
	)
}
